/**
 * a wrapper function for site tracking calls to short-circuit when Cypress
 * integration tests run
 */
export const ignoreCypress = (func: Function) => {
  // ignore the test runner environment
  if (window.Cypress) {
    return () => {}
  }
  return func
}
